/**
 * Whether the practice has vetted a booking (PRD #1343). Orthogonal to
 * `AppointmentStatus` and unrelated to the delivery-confirmation statuses
 * (`AWAITING_CONFIRMATION`/`LAPSED`), which answer "did the appointment
 * happen?". This answers "has the front desk accepted this booking?".
 *
 * Every practice-created appointment is `CONFIRMED` from birth. A patient
 * self-booking is a `PENDING` hold: it blocks the slot immediately but must
 * not reach billing until the practice confirms. Decline/withdraw route
 * through the existing cancel path (status → CANCELLED); this field stays
 * `PENDING` on a declined hold — it never gains a terminal value of its own.
 */
export var PracticeConfirmation;
(function (PracticeConfirmation) {
    PracticeConfirmation["CONFIRMED"] = "confirmed";
    PracticeConfirmation["PENDING"] = "pending";
})(PracticeConfirmation || (PracticeConfirmation = {}));
//# sourceMappingURL=practice-confirmation.enum.js.map